import { useNavigate } from 'react-router-dom'
import { useEffect } from 'react'

const Dashboard = () => {
  const navigate = useNavigate()

  useEffect(() => {
    navigate('/admin/users')
  }, [])
}

export default Dashboard
